export default "__VITE_ASSET__DiWJa4Sw__"